import React, { useEffect, useRef } from 'react';
import { MicOff, MonitorUp } from 'lucide-react';

const playable = (t) => (t?.state === 'playable' ? t.persistentTrack : null);

export default function VideoTile({ p, badge, speaking, screen = false, testId }) {
  const vref = useRef(null);
  const aref = useRef(null);
  const vTrack = playable(screen ? p.tracks?.screenVideo : p.tracks?.video);
  const aTrack = !p.local && !screen ? playable(p.tracks?.audio) : null;
  useEffect(() => {
    if (!vref.current) return;
    vref.current.srcObject = vTrack ? new MediaStream([vTrack]) : null;
    if (vTrack) vref.current.play?.().catch(() => {});
  }, [vTrack]);
  useEffect(() => {
    if (!aref.current) return;
    aref.current.srcObject = aTrack ? new MediaStream([aTrack]) : null;
    if (aTrack) aref.current.play?.().catch(() => {});
  }, [aTrack]);
  const muted = !screen && p.tracks?.audio?.state === 'off';
  const name = p.local ? `${p.user_name || 'You'} (you)` : p.user_name || 'Guest';
  return (
    <div className={`vr-tile ${speaking ? 'is-speaking' : ''} ${screen ? 'is-screen' : ''}`} data-testid={testId}>
      <video ref={vref} autoPlay playsInline muted className={p.local && !screen ? 'is-mirror' : ''} />
      {!vTrack && <div className="vr-avatar"><span>{(p.user_name || '?').slice(0, 1).toUpperCase()}</span></div>}
      {aTrack && <audio ref={aref} autoPlay />}
      <div className="vr-tag">
        {screen && <MonitorUp size={12} />}
        {muted && <MicOff size={12} aria-label="Muted" />}
        <span>{screen ? `${name}'s screen` : name}</span>
        {badge && <em>{badge}</em>}
      </div>
    </div>
  );
}
